import React, { Component } from 'react';
import Header from '../../Header';
import MessageLink from '../../MessageLink';
import Footer from '../../Footer';
import BannerSingle from '../../BannerSingle';
import PageDescription from '../../PageDescription';
import Lgpd from '../../Lgpd';
import ErrorBoundary from '../../ErrorHandler/ErrorBoundary';
import FiltroComunicados from '../../Filtros/FiltroComunicados';

class ApresentacoesEspeciais extends Component {

	render() {

		return (

			<div>
				{/* HEADER */}{/* LOGIN */}

				<ErrorBoundary>
					<Header />
				</ErrorBoundary>

				<ErrorBoundary>
					<BannerSingle image={'apresentacoes-especiais'} page={'apresentacoes-especiais'} />
				</ErrorBoundary>
				{/* Page description */}
				<ErrorBoundary><PageDescription page={"apresentacoes-especiais"} /></ErrorBoundary>

				<ErrorBoundary><FiltroComunicados url={"/ObterapresentacoesEspeciais"} urlFiltro={"/ObterapresentacoesEspeciais?"} /></ErrorBoundary>

				{/* Content page */}
				{/* FOOTER */}
				<ErrorBoundary><Footer /></ErrorBoundary>
				{/* Message Link */}
				<ErrorBoundary><MessageLink /></ErrorBoundary>
				{/* LGPD */}
				<ErrorBoundary><Lgpd /></ErrorBoundary>
			</div>
		);
	}
};

export default ApresentacoesEspeciais;